var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3602 11.9348C23.1637 11.6659 18.4808 5.35168 12.4999 5.35168C6.51902 5.35168 1.83593 11.6659 1.63961 11.9345C1.45346 12.1896 1.45346 12.5355 1.63961 12.7906C1.83593 13.0594 6.51902 19.3737 12.4999 19.3737C18.4808 19.3737 23.1637 13.0594 23.3602 12.7908C23.5466 12.5358 23.5466 12.1896 23.3602 11.9348ZM12.4999 17.9231C8.09435 17.9231 4.27867 13.7322 3.14915 12.3622C4.27721 10.9909 8.08489 6.80223 12.4999 6.80223C16.9052 6.80223 20.7207 10.9924 21.8507 12.3632C20.7226 13.7344 16.9149 17.9231 12.4999 17.9231Z",
    fill: "#D83612"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 8.01111C10.1005 8.01111 8.14825 9.96331 8.14825 12.3628C8.14825 14.7622 10.1005 16.7145 12.4999 16.7145C14.8994 16.7145 16.8516 14.7622 16.8516 12.3628C16.8516 9.96331 14.8994 8.01111 12.4999 8.01111ZM12.4999 15.2639C10.9002 15.2639 9.59883 13.9625 9.59883 12.3628C9.59883 10.7631 10.9002 9.46169 12.4999 9.46169C14.0996 9.46169 15.401 10.7631 15.401 12.3628C15.401 13.9625 14.0997 15.2639 12.4999 15.2639Z",
    fill: "#D83612"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOpen);
export default __webpack_public_path__ + "static/media/viewOpen.a4f5be11542aac3718d573c3da90a97d.svg";
export { ForwardRef as ReactComponent };